/**
 * Export configuration for TAP Jobs
 */

// Fields to include when exporting jobs to CSV (matches API response shape)
export const JOBS_EXPORT_FIELDS = [
  "id",
  "jobType",
  "jobStatus",
  "startedByUser",
  "targetCount",
  "progressCount",
  "errorCount",
  "createdAt",
  "modifiedAt",
  "completedAt",
];

// Range for fetching all jobs for export (up to 999 items)
export const JOBS_EXPORT_RANGE = "0,999";
